var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container content-padding" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(
              "\n        นโยบายความเป็นส่วนตัวผู้ให้บริการภายใต้สังกัด\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", [
            _c("p", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("บริษัท บีนีท จำกัด")
              ]),
              _vm._v(
                " (“บริษัท”) ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลได้จัดทำและมีจุดประสงค์แจ้งนโยบายความเป็นส่วนตัวของผู้ให้บริการภายใต้สังกัดฉบับนี้ (“"
              ),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("นโยบาย")
              ]),
              _vm._v(
                "”) ที่กำหนดเกี่ยวกับสิทธิ เงื่อนไขและความจำเป็นของบริษัทในการเก็บ ประมวลผล และใช้ข้อมูลส่วนบุคคลของท่าน (“"
              ),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("ท่าน")
              ]),
              _vm._v(
                "” หรือ “ผู้ให้บริการ”) ซึ่ง (1) ให้ความสนใจสมัครเป็นผู้ให้บริการผ่านแพลตฟอร์มการให้บริการของบริษัท (“"
              ),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("แพลตฟอร์ม")
              ]),
              _vm._v(
                "”) และ (2) ซึ่งได้รับเลือกให้เป็นผู้ให้บริการผ่านแพลตฟอร์มการให้บริการของบริษัท ให้แก่ผู้ใช้ บริการ (“"
              ),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("ผู้ใช้บริการ")
              ]),
              _vm._v(
                "”)\n          เพื่อให้รับทราบ ทั้งนี้ เมื่อท่านติดต่อมายังบริษัทผ่านช่องทางต่างๆ รวมถึงสมัครเพื่อให้บริการผ่านแพลตฟอร์มของบริษัท ทางบริษัทจะถือว่าท่านตกลงและรับทราบนโยบายฉบับนี้แล้ว ทั้งนี้ บริษัทอาจปรับปรุงนโยบายฉบับนี้ตามแต่ละระยะเวลา โดยบริษัทจะแจ้งให้ท่านทราบถึงการเปลี่ยนแปลงผ่านทางช่องทางการติดต่อสื่อสารที่บริษัทมีกับท่าน\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("ข้อมูลส่วนบุคคลที่บริษัทประมวลผล")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทอาจได้รับข้อมูลส่วนบุคคลของท่าน โดยตรงจากการติดต่อสอบถามผ่านช่องทางต่าง ๆ การกรอกและนำส่งข้อมูลในใบสมัครงานรวมถึงเอกสารแบบฟอร์มอื่นใด รวมไปถึงการการสนทนาสื่อสารต่างๆ และอาจได้รับข้อมูลจากบุคคลอื่น เช่น จากการแนะนำของผู้ให้บริการใต้สังกัดท่านอื่น ซึ่งในกรณีที่บริษัทได้รับข้อมูลของท่านจากแหล่งข้อมูลทางอ้อม บริษัทจะแจ้งให้ท่านทราบในทันที ทั้งนี้ เพื่อการติดต่อประสานงาน การพิจารณาคุณสมบัติการเป็นพนักงาน การปฏิบัติหน้าที่และสิทธิภายใต้สัญญาการให้บริการระหว่างผู้ให้บริการและบริษัท\n          และเพื่อการป้องกันสิทธิอันชอบด้วยกฎหมายของบริษัท บริษัทมีความจำเป็นต้องประมวลผลข้อมูลส่วนบุคคลของท่าน ในแต่ละขั้นตอน ดังต่อไปนี้\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticStyle: { "text-decoration": "underline" } }, [
                _vm._v("ในระหว่างขั้นตอนการสมัคร")
              ]),
              _vm._v(
                " บริษัทมีความจำเป็นในการเก็บ รวบรวม ใช้ข้อมูลส่วนบุคคลของท่าน ได้แก่ ข้อมูลของท่านในฐานะผู้สมัครตามที่ระบุไว้ในใบสมัครงาน กล่าวคือ ชื่อนามสกุล เลขบัตรประจำตัวประชาชน เพศ วันเกิด ข้อมูลการติดต่อ (ที่อยู่ เบอร์โทรศัพท์และอีเมล) ข้อมูลการศึกษาและอาชีพ รวมถึงประวัติการทำงาน ประเภทงานที่ต้องการให้บริการ และเมื่อได้รับความยินยอมจากท่าน บริษัทจะเก็บรวบรวมข้อมูลประวัติสุขภาพ โดยเฉพาะโรคร้ายแรง\n          และข้อมูลประวัติอาชญากรรมของท่าน ซึ่งเป็นข้อมูลสำคัญต่อการประเมินความเหมาะสมในการรับตำแหน่งงาน\n          นอกจากข้อมูลของท่านผู้สมัครเอง บริษัทมีความจำเป็นต้องเก็บรวบรวมข้อมูลของบุคคลอื่น โดยเฉพาะผู้ที่ติดต่อได้กรณีฉุกเฉิน ได้แก่ ชื่อนามสกุลและเบอร์ติดต่อ ทั้งนี้ ในกรณีที่ท่านเป็นผู้ให้ข้อมูลของบุคคลที่เกี่ยวข้องตามที่ระบุไว้ข้างต้น บริษัทจะถือว่า ท่านให้การรับประกันว่า ท่านมีสิทธิอันชอบด้วยกฎหมายในการเปิดเผยข้อมูลส่วนบุคคลของบุคคลดังกล่าว และได้แจ้งความจำเป็นในการประมวลผลข้อมูลส่วนบุคคลแล้ว\n          ดังนั้นบริษัทสามารถประมวลผลข้อมูลส่วนบุคคลของบุคคลที่เกี่ยวข้องดังกล่าวได้โดยสมบูรณ์ภายใต้นโยบายฉบับนี้\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticStyle: { "text-decoration": "underline" } }, [
                _vm._v("ในกรณีได้รับการคัดเลือกให้เป็นผู้ให้บริการ")
              ]),
              _vm._v("ภายใต้สังกัดของบริษัท และ"),
              _c("span", { staticStyle: { "text-decoration": "underline" } }, [
                _vm._v("ระหว่างระยะเวลาการให้บริการ")
              ]),
              _vm._v(
                " บริษัทมีความจำเป็นในการเก็บ รวบรวม ใช้ข้อมูลส่วนบุคคลของท่านเพิ่มเติมจากในขั้นตอนการสมัครงาน ดังนี้ (ก) ข้อมูลการผ่านการฝึกอบรมที่กำหนด และข้อมูลรวมถึงลายเซ็นที่มีการดำเนินการในข้อตกลงหรือสัญญาการให้บริการ แนบมาพร้อมเอกสารยืนยันตัวตนของท่านอาทิ สำเนาบัตรประชาชน สำเนาทะเบียนบ้าน (ข)\n          ข้อมูลเพื่อการสร้าง profile ผู้ให้บริการของบริษัท รวมถึงภาพถ่าย Profile ของท่าน (ค) ข้อมูลประวัติการทำงาน ได้แก่แต่ไม่จำกัดเพียง ข้อมูลธุรกรรมการใช้บริการแพลตฟอร์ม ข้อมูลการให้บริการแก่ผู้ใช้บริการ ข้อมูลการทำงานที่จะได้รับค่าตอบแทน (ง) ข้อมูลการชำระเงินที่บริษัทดำเนินการให้แก่ท่าน อาทิเช่น สำเนาบัญชีธนาคาร และรายละเอียดการชำระเงิน (จ) ในกรณีได้รับความยินยอมโดยชัดแจ้งจากท่าน อาจรวมถึงข้อมูลส่วนบุคคลอ่อนไหวอื่น ๆ เช่น ข้อมูลประวัติการรับการรับวัคซีน Covid-19 และผลตรวจ ATK\n          ซึ่งเป็นข้อมูลที่จำเป็นสำหรับการให้บริการผ่านแพลตฟอร์ม ให้แก่ ผู้ใช้บริการ\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("วัตถุประสงค์และระยะเวลาการประมวลผลข้อมูลส่วนบุคคล")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทมีความจำเป็นต้องเก็บ รวบรวม ใช้ และประมวลผลข้อมูลส่วนบุคคลของท่าน เพื่อวัตถุประสงค์และระยะเวลา ดังนี้:\n        "
              )
            ]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [
                    _vm._v(
                      "เพื่อการพิจารณาคัดเลือก และการปฏิบัติหน้าที่และสิทธิตามสัญญาที่บริษัทอาจมีกับท่าน"
                    )
                  ]
                ),
                _vm._v(
                  " บริษัทมีความจำเป็นต้องประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ ดังนี้ (ก) การติดต่อประสานงาน การตรวจสอบประเมินความเหมาะสมของท่านในการรับหน้าที่เป็นผู้ให้บริการผ่านแพลตฟอร์ม (ข) การจัดทำข้อตกลง การบริหารจัดการดูแลการจ่ายค่าจ้าง การตรวจสอบดูแลการปฏิบัติงานของท่าน\n            ตามที่ตกลงไว้ในข้อตกลงการให้บริการที่บริษัทอาจกำหนดเป็นเงื่อนไขเพื่อการให้บริการผ่านทางแพลตฟอร์ม (ค) การติดต่อสื่อสาร ประสานงานกับท่าน เพื่อวัตถุประสงค์ในการควบคุมดูแลและ/หรือการบริหารจัดการความสัมพันธ์การจ้างงานระหว่างท่านกับบริษัทหรือการติดต่อในกรณีฉุกเฉิน ทั้งนี้ บริษัทมีความจำเป็นในการจัดเก็บและรักษาข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ดังกล่าว ตลอดระยะเวลาที่จำเป็นสำหรับการคัดเลือกการเป็นผู้ให้บริการและตลอดระยะเวลาตามที่ตกลงไว้ในข้อตกลงการทำงานของท่าน\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("เพื่อการปฏิบัติหน้าที่ภายใต้กฎหมายของบริษัท")]
                ),
                _vm._v(
                  " บริษัทจำเป็นต้องประมวลผลข้อมูลส่วนบุคคลของท่าน เพื่อจุดประสงค์เฉพาะ ได้แก่ การหักภาษี ณ ที่จ่าย รวมถึงการจัดทำเอกสารทางการบัญชี โดยบริษัทจำเป็นต้องเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้ตามระยะเวลาที่กฎหมายที่เกี่ยวข้องกำหนดไว้\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("เพื่อสิทธิประโยชน์อันชอบด้วยกฎหมายของบริษัท")]
                ),
                _vm._v(
                  " บริษัทอาจประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ ดังนี้ โดยรับประกันไม่ให้กระทบสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคลมากเกินสมควร (ก) กรณีการสมัครเป็นผู้ให้บริการ หากท่านไม่ได้รับการคัดเลือกในทันที บริษัทอาจติดต่อกลับไปหาท่านอีกครั้งหากมีตำแหน่งว่างและท่านมีความเหมาะสมในอนาคตภายในระยะเวลา 1 ปีปฏิทิน (ข) การดำเนินกระบวนการทางกฎหมาย เพื่อให้ได้มาซึ่งสิทธิตามกฎหมาย\n            และการเยียวยาความเสียหาย และการบริหารจัดการข้อร้องเรียนหรือข้อเรียกร้องใด ๆ ระหว่างบริษัท ท่านและผู้ใช้บริการผ่านแพลตฟอร์ม เป็นระยะเวลา 1 ปีภายหลังจากสิ้นสุดข้อตกลงการให้บริการ (ค) การเก็บบันทึก จัดทำทะเบียนผู้ให้บริการเพื่อการตรวจสอบคุณสมบัติการทำงานของท่าน (ง) การบริหารจัดการความเสี่ยง การควบคุมและกำกับดูแลการทำงานภายในของบริษัท ผ่านกระบวนการต่าง ๆ (จ) การวิเคราะห์เพื่อปรับปรุงการกำหนดเงื่อนไขและข้อตกลงการทำงานของบริษัทและผู้ให้บริการโดยรวม (ง)\n            การใช้ภาพการให้บริการของท่านในการเข้าร่วมการฝึกอบรมหรือกิจกรรมต่าง ๆ เพื่อจัดทำสื่อประชาสัมพันธ์ ทั้งนี้ เพื่อการใช้สิทธิอันชอบด้วยกฎหมายของบริษัทนี้นอกจากที่กำหนดระยะเวลาไว้เป็นการเฉพาะ บริษัทสงวนสิทธิที่จะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้ตลอดระยะเวลาที่บริษัทอาจมีความจำเป็นในการดำเนินการแต่ละวัตถุประสงค์ดังกล่าว\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [_vm._v("กรณีที่ท่านให้ความยินยอมเป็นการเฉพาะ")]
                ),
                _vm._v(
                  " บริษัทอาจดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์เฉพาะที่ท่านให้ความยินยอมไว้ ซึ่งอาจรวมถึง (ก) การประมวลผลและเผยแพร่ข้อมูลประวัติการรับการรับวัคซีน Covid-19 และผลตรวจ ATK ซึ่งเป็นข้อมูลที่จำเป็นสำหรับการให้บริการผ่านแพลตฟอร์มแก่ผู้ใช้บริการ (ข) การจัดทำสื่อประชา สัมพันธ์โดยอ้างอิงจากภาพถ่ายไม่ว่าจะเป็นภาพนิ่งหรือภาพเคลื่อนไหวของท่าน\n            ซึ่งจะได้รับการจัดทำเป็นหลายรูปแบบทั้งสื่อสิ่งพิมพ์และอิเล็กทรอนิกส์\n          "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("การเปิดเผยข้อมูลส่วนบุคคล")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          โดยหลักการแล้ว บริษัทจะไม่เปิดเผยส่งต่อข้อมูลส่วนบุคคลของท่านให้แก่บุคคลภายนอก แต่ในกรณีจำเป็นบริษัทอาจมีความจำเป็นต้องเปิดเผยและส่งต่อข้อมูลส่วนบุคคลของท่านให้แก่บุคคลดังต่อไปนี้ (ก) ผู้ใช้บริการแพลตฟอร์ม ซึ่งบริษัทจำเป็นต้องเปิดเผยข้อมูล Profile ของท่านเท่าที่จำเป็นเพื่อให้ผู้ใช้บริการใช้เพื่อพิจารณาคัดเลือกผู้ให้บริการ และต้องส่งต่อเปิดเผยข้อมูลของท่านเพื่อการติดต่อประสานงานโดยตรงระหว่างท่านและผู้ใช้บริการดังกล่าว ภายใต้เงื่อนไขการให้บริการแพลตฟอร์ม (ข) ผู้ให้บริการภายนอกของบริษัท\n          ได้แก่แต่ไม่จำกัดเพียง ผู้ให้บริการจัดการการชำระค่าจ้าง ผู้ให้บริการด้านเทคโนโลยีสารสนเทศ รวมถึงผู้ให้บริการในการดำเนินธุรกิจของบริษัท เช่น ที่ปรึกษาต่าง ๆ (รวมถึงผู้ตรวจสอบบัญชีหรือที่ปรึกษาทางด้านกฎหมาย) ทั้งนี้ การเปิดเผยข้อมูลส่วนบุคคลดังกล่าวจะดำเนินการเฉพาะภายใต้ขอบเขตที่จำเป็น ภายใต้เอกสารสัญญาการประมวลผลข้อมูลส่วนบุคคล ที่จะมีการลงนามระหว่างบริษัทและบุคคลที่ได้รับการเปิดเผยข้อมูลส่วนบุคคลดังกล่าว (ค) หน่วยงานของรัฐ รวมถึงแต่ไม่จำกัดเพียง กรมสรรพากร\n          ศาลและองค์คณะในการระงับข้อพิพาทอื่นใด หรือหน่วยงานราชการอื่นที่บริษัทอาจอยู่ภายใต้บังคับของคำสั่ง กฎหมาย หรือคำพิพากษาให้ต้องเปิดเผยข้อมูลของพนักงานให้แก่หน่วยงานราชการดังกล่าว (ง) ในกรณีได้รับความยินยอมโดยชัดแจ้งจากท่าน บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลให้แก่ บริษัทในเครือที่อาจมีตำแหน่งงานที่เหมาะสมกับท่าน หรือบุคคลอื่นตามที่ท่านระบุและแจ้งให้บริษัททราบ\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "font-weight-bold",
                staticStyle: { "text-decoration": "underline" }
              },
              [_vm._v("มาตรการรักษาความปลอดภัยของข้อมูลส่วนบุคคล")]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทรับประกันการจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยที่เหมาะสม ภายใต้กฎหมายที่เกี่ยวข้องเพื่อป้องกันการเข้าถึง การใช้ การเปลี่ยนแปลง การแก้ไข หรือการเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจหรือโดยมิชอบ ทั้งนี้ บริษัทจะทบทวนมาตรการดังกล่าวเป็นระยะ เพื่อให้สอดคล้องและเหมาะสมตามมาตรฐานในอุตสาหกรรมและการเปลี่ยนแปลงของกฎหมายที่เกี่ยวข้อง\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "text-decoration": "underline" } }, [
              _vm._v("\n          สิทธิของเจ้าของข้อมูล\n        ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัทเคารพสิทธิตามกฎหมายของท่านในฐานะเจ้าของข้อมูลในส่วนที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่านที่อยู่ในการควบคุมของบริษัท โดยท่านสามารถขอใช้สิทธิที่มีดังต่อไปนี้ได้ตามกรอบของกฎหมายที่เกี่ยวข้อง (1) สิทธิเพิกถอนความยินยอม (2) สิทธิขอเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคล (3) สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (4) สิทธิขอรับข้อมูลส่วนบุคคล ในกรณีที่บริษัททำให้ข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติ\n          รวมถึงสิทธิขอให้ส่งหรือโอนข้อมูลรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น (5) สิทธิคัดค้านการประมวลผลข้อมูลส่วนบุคคล (6) สิทธิขอให้ลบหรือทำลายหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลได้ เมื่อข้อมูลนั้นหมดความจำเป็น (7) สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคล หรือ(8) สิทธิในการร้องเรียนกรณีเกิดการละเมิดข้อมูลส่วนบุคคลได้ โดยติดต่อบริษัทที่ โทร 02-113 1138 หรือ Email: Info@BeNeat.co\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-5" }, [
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v("นโยบายคุ้มครองข้อมูลส่วนบุคคล")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บริษัท บีนีท จำกัด (“บีนีท”) เป็นบริษัทประกอบกิจการให้บริการการทำความสะอาดประเภทต่างๆ และงานบริการอื่นๆ ผ่านระบบและขั้นตอนของบีนีทแพลตฟอร์ม บีนีทตระหนักถึงความสำคัญของการรักษาความปลอดภัยของข้อมูลส่วนบุคคลที่ผู้ให้ข้อมูลได้ให้ไว้กับบีนีทผ่านช่องทางต่างๆ บีนีทจึงขอแจ้งให้ทราบถึงนโยบายความเป็นส่วนตัว (“นโยบาย”) อันเกี่ยวข้องกับวิธีการเก็บรวบรวม การดำเนินการ และการใช้ข้อมูลส่วนบุคคล บีนีทจะดำเนินมาตรการที่เข้มงวดในการรักษาความมั่นคงปลอดภัย เมื่อผู้ให้ข้อมูลมีนิติสัมพันธ์ ติดต่อ\n          หรือใช้บริการและ/หรือผลิตภัณฑ์ของบีนีทผ่านช่องทางต่างๆ ที่บีนีทกำหนด ภายใต้กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v("ข้อ 1. คำนิยามศัพท์")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "ถ้อยคำต่อไปนี้ให้มีความหมายดังนี้ เว้นแต่จะมีข้อความกำหนดไว้เป็นอย่างอื่น"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("“ข้อมูลส่วนบุคคล”")
              ]),
              _vm._v(
                " หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ ไม่ว่าทางตรงหรือทางอ้อมแต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม ตัวอย่างเช่น ชื่อ นามสกุล หมายเลขโทรศัพท์ ที่อยู่ อีเมล์ หมายเลขบัตรประจำตัวประชาชน เป็นต้น\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("“ข้อมูลส่วนบุคคลที่มีความอ่อนไหว”")
              ]),
              _vm._v(
                " หมายถึง ข้อมูลส่วนบุคคลที่กฎหมายกำหนดเป็นการเฉพาะ เช่น เชื้อชาติความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนา หรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ (Biometric) หรือข้อมูลอื่นใดในทำนองเดียวกันที่กฎหมายกำหนด ซึ่งบีนีทจะต้องดำเนินการด้วยความระมัดระวังเป็นพิเศษ\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("“ประมวลผล”")
              ]),
              _vm._v(
                " หมายถึง การดำเนินการใดๆ ต่อข้อมูลส่วนบุคคลของ ซึ่งรวมถึงการเก็บรวมรวม, การใช้, การจัดเก็บ, การเปิดเผย และการลบข้อมูลส่วนบุคคล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("“ฐานการประมวลผล”")
              ]),
              _vm._v(
                " หมายถึง เหตุผลความจำเป็นในการประมวลผลข้อมูลส่วนบุคคลตามมาตรา 24 และ 26 ของกฎหมายคุ้มครองข้อมูลส่วนบุคคลฯ\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 2. ข้อมูลส่วนบุคคลที่บีนีทจะทำการเก็บรวบรวม ใช้ หรือเปิดเผย\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บีนีทจะทำการเก็บรวบรวม ใช้ และเปิดเผย ข้อมูลของส่วนบุคคลและหรือข้อมูลส่วนบุคคลที่มีความอ่อนไหวที่บีนีทได้รับไม่ว่าทางตรง ทางอ้อม หรือจากแหล่งอื่น ผ่านกระบวนการหรือช่องทาง เช่น อีเมล์, แอปพลิเคชัน LINE, เว็บไซต์, แฟกซ์, แบบฟอร์มลงทะเบียน, แบบฟอร์มสมัครใช้งาน เป็นต้น นอกจากนี้ บีนีทอาจเก็บรวบรวมข้อมูลส่วนบุคคลของบุคคลที่สามที่มีความเกี่ยวข้องกับผู้ให้ข้อมูล รวมถึงติดต่อสอบถามข้อมูล กรณีไม่สามารถติดต่อผู้ให้ข้อมูลได้\n          ทั้งนี้บีนีทจะเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้ให้ข้อมูลโดยตรงหรือจากหน่วยงานภายนอก ตามวัตถุประสงค์ของบีนีทต่อไปโดยจะจัดเก็บเท่าที่จำเป็นเพื่อบรรลุวัตถุประสงค์ที่แจ้งไว้แก่ผู้ให้ข้อมูล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 3. วัตถุประสงค์ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บีนีทมีความจำเป็นที่ต้องประมวลผลข้อมูลส่วนบุคคลตามวัตถุประสงค์ที่แจ้งไว้แก่ผู้ให้ข้อมูล โดยหมายรวมแต่ไม่จำกัดเพียงวัตถุประสงค์ดังต่อไปนี้\n        "
              )
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "dash" }, [
              _c("li", [
                _vm._v(
                  "\n            เพื่อปฏิบัติตามสัญญาระหว่างบีนีทกับผู้ให้ข้อมูล ในการให้บริการและ/หรือผลิตภัณฑ์ของบีนีท และเพื่อดำเนินการตามคำขอของผู้ให้ข้อมูล หรือ เพื่อดำเนินการให้บรรลุวัตถุประสงค์ของข้อตกลงหรือสัญญาใดๆ ระหว่างบีนีทและผู้ให้ข้อมูล\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n            เพื่อพิจารณาอนุมัติสถานภาพการเป็นสมาชิกและ/หรือผู้ให้บริการอิสระและ/หรือการดำเนินการใดๆ ที่เกี่ยวข้องกับการใช้บีนีทแพลตฟอร์มและ/หรือบริการต่างๆ เช่น การประมวลผล การติดต่อ การแจ้ง การมอบงานให้แก่บุคคลอื่นที่เป็นผู้ให้บริการภายนอก การโอนสิทธิและ/หรือหน้าที่ การแจ้งเตือนการชำระค่างวดค่าใช้จ่ายต่างๆ เป็นต้น\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n            เพื่อปฏิบัติตามกฎหมายและกฎเกณฑ์ ซึ่งรวมถึงการปฏิบัติตามคำสั่งศาลหรือหน่วยงานทางการที่กำกับดูแลบีนีทและหน่วยงานอื่นที่มีอำนาจให้เป็นไปเพื่อประโยชน์โดยชอบด้วยกฎหมาย เช่น การบริหารความเสี่ยง การรักษาความปลอดภัยของระบบและเครือข่าย เป็นต้น\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n            เพื่อดำเนินการใดๆ ตามที่ได้รับความยินยอมจากผู้ให้ข้อมูลแล้ว เช่น เพื่อการประชาสัมพันธ์หรือแนะนำผลิตภัณฑ์และ/หรือบริการ เป็นต้น\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 4. การเปิดเผยและการใช้ข้อมูลส่วนบุคคลของผู้ให้ข้อมูลร่วมกับบุคคลที่สาม\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          หากผู้ให้ข้อมูลได้ให้ความยินยอมและ/หรือเป็นการจำเป็นในการปฏิบัติตามสัญญา หรือเป็นไปตามความจำเป็นเพื่อประโยชน์อันชอบด้วยกฎหมาย บีนีทอาจส่ง โอน และ/หรือเปิดเผยข้อมูลส่วนบุคคลใดๆ ไปยังบุคคลอื่นทั้งที่อยู่ในประเทศไทยและต่างประเทศ โดยบีนีทอาจเปิดเผยหรือใช้ข้อมูลของผู้ให้ข้อมูลตามวัตถุประสงค์ดังกล่าวข้างต้นกับบุคคลดังต่อไปนี้ เช่น\n        "
              )
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "dash" }, [
              _c("li", [
                _vm._v(
                  "บริษัทในกลุ่มธุรกิจของบีนีททั้งที่อยู่ในประเทศไทยและ/หรือต่างประเทศ รวมถึง กรรมการ พนักงาน หรือตัวแทนของบริษัทเหล่านั้น และพันธมิตรทางธุรกิจของบีนีท"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "หน่วยงานทางการที่กำกับดูแลบีนีท ศาล ตำรวจ ตลาดหลักทรัพย์แห่งประเทศไทย หรือหน่วยงานทางการอื่นใดที่มีอำนาจและ/หรือมีคำสั่งให้บีนีทส่งข้อมูลส่วนบุคคลของผู้ให้ข้อมูลหรือนำส่งทรัพย์สิน เช่น กรมบังคับคดี กรมสรรพากร เป็นต้น"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "หน่วยงาน องค์กร ผู้ให้บริการภายนอก ที่ปรึกษาทางกฎหมาย หรือนิติบุคคลอื่นใดที่มีสัญญากับบีนีท หรือที่บีนีทเป็นคู่สัญญา หรือที่บีนีทมีความสัมพันธ์ด้วย ซึ่งบีนีทมีความจำเป็นที่จะต้องเปิดเผยข้อมูลส่วนบุคคลเพื่อการให้บริการและ/หรือผลิตภัณฑ์ของบีนีท"
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 5. การใช้ข้อมูลเพื่อวัตุประสงค์ทางการตลาด\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บีนีทอาจใช้ข้อมูลส่วนบุคคลของผู้ให้ข้อมูลเพื่อการตลาดในการวิเคราะห์ วิจัยทางการตลาด ซึ่งมีวัตถุประสงค์ในการพัฒนาการบริการและ/หรือผลิตภัณฑ์ของบีนีท รวมไปถึงการประชาสัมพันธ์และการส่งเสริมการตลาดต่างๆ ของบีนีท\n          ทั้งนี้ บีนีทจะใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังกล่าวข้างต้นก็ต่อเมื่อบีนีทได้รับความยินยอมจากผู้ให้ข้อมูล ในกรณีที่ผู้ให้ข้อมูลไม่ให้ความยินยอม บีนีทจะไม่นำข้อมูลของผู้ให้ข้อมูลไปใช้ในทางการตลาด และผู้ให้ข้อมูลมีสิทธิถอนความยินยอมดังกล่าวเมื่อใดก็ได้ ในกรณีที่ถอนความยินยอมแล้ว บีนีทจะเลิกส่งข้อมูลทางการตลาดให้แก่ผู้ให้ข้อมูลทันที และจะเลิกนำข้อมูลส่วนบุคคลของผู้ให้ข้อมูลไปใช้ในทางการตลาดทันที แต่อย่างไรก็ตาม บีนีทจำเป็นต้องบันทึกการถอนความยินยอมดังกล่าวไว้\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 6. สิทธิของผู้ให้ข้อมูลส่วนบุคคล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("ผู้ให้ข้อมูลมีสิทธิในข้อมูลส่วนบุคคลดังต่อไปนี้")
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "dash" }, [
              _c("li", [
                _vm._v(
                  "สิทธิในการเพิกถอนความยินยอม ในกรณีที่บีนีทขอความยินยอมของผู้ให้ข้อมูลเพื่อประมวลผลข้อมูลส่วนบุคคลของผู้ให้ข้อมูล"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "สิทธิในการเข้าถึงข้อมูลส่วนบุคคล โดยผู้ให้ข้อมูลสามารถขอรับสำเนาข้อมูลของผู้ให้ข้อมูลและตรวจสอบว่าบีนีทได้ประมวลผลข้อมูลของผู้ให้ข้อมูลตามกฎหมายหรือไม่"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "สิทธิในการโอนข้อมูลส่วนบุคคล ในกรณีที่บีนีทได้จัดทำข้อมูลส่วนบุคคลในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติ และสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ ผู้ให้ข้อมูลสามารถขอให้ส่งหรือโอนข้อมูลส่วนบุคคลของผู้ให้ข้อมูลไปยังหน่วยงานอื่นได้ด้วยวิธีการอัตโนมัติ หรือขอรับข้อมูลส่วนบุคคลที่บีนีทส่งหรือโอนไปยังหน่วยงานอื่นโดยตรงเว้นแต่โดยสภาพทางเทคนิคไม่สามารถทำได้"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล โดยผู้ให้ข้อมูลสามารถคัดค้านในกรณีที่บีนีทประมวลผลข้อมูลของผู้ให้ข้อมูลเพื่อการใช้ข้อมูลส่วนบุคคลของตนเพื่อการตลาดทางตรง ผู้ให้ข้อมูลนสามารถคัดค้านได้เสมอ เว้นแต่ในบางกรณีบีนีทประมวลผลข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ในการวิจัยทางวิทยาศาสตร์หรือในอดีตหรือวัตถุประสงค์ทางสถิติ หรือบีนีทมีเหตุผลอันชอบธรรมที่น่าสนใจสำหรับข้อมูลที่จำเป็นต้องได้รับการประมวลผลซึ่งแทนที่ผลประโยชน์สิทธิและเสรีภาพของแต่ละบุคคลไม่ว่าจะเป็น การเกิดอุบัติเหตุ\n            หรือสิทธิประโยชน์ที่จะได้รับจากภาครัฐ\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "สิทธิในการลบข้อมูลส่วนบุคคล โดยผู้ให้ข้อมูลสามารถขอให้บีนีทลบข้อมูล หรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวผู้ให้ข้อมูลได้ ในกรณีดังต่อไปนี้\n            "
                ),
                _c("ul", { staticClass: "ml-5", attrs: { type: "circle" } }, [
                  _c("li", [
                    _vm._v("เมื่อหมดความจำเป็นในการประมวลผลข้อมูลส่วนบุคคล")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "เมื่อผู้ให้ข้อมูลถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลและบีนีทไม่มีเหตุผลตามกฎหมายที่จะประมวลผลข้อมูลส่วนบุคคลนั้นได้ต่อไป"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "เมื่อผู้ให้ข้อมูลคัดค้านการประมวลผลข้อมูลส่วนบุคคลของผู้ให้ข้อมูลแล้ว"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "เมื่อข้อมูลส่วนบุคคลได้ถูกประมวลผลโดยไม่ชอบด้วยกฎหมาย"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n            สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (Right to Restrict Processing) โดยผู้ให้ข้อมูลสามารถขอให้ระงับการใช้ข้อมูลส่วนบุคคลของผู้ให้ข้อมูลได้ ในกรณีดังต่อไปนี้\n            "
                ),
                _c("ul", { staticClass: "ml-5", attrs: { type: "circle" } }, [
                  _c("li", [
                    _vm._v(
                      "เมื่ออยู่ในระหว่างการตรวจสอบตามที่ผู้ให้ข้อมูลขอให้แก้ไขข้อมูลส่วนบุคคล"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "เมื่อเป็นข้อมูลส่วนบุคคลที่ต้องลบหรือทำลาย แต่ผู้ให้ข้อมูลขอให้ระงับการใช้แทน"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "เมื่อข้อมูลส่วนบุคคลหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ แต่ผู้ให้ข้อมูลมีความจำเป็นต้องขอให้เก็บรักษาไว้เพื่อใช้ในการก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "เมื่ออยู่ในระหว่างการพิสูจน์ หรือตรวจสอบ ตามคำขอใช้สิทธิในการคัดค้านของผู้ให้ข้อมูล"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n            สิทธิในการแก้ไขข้อมูลส่วนบุคคล (Right to Rectification) โดยผู้ให้ข้อมูลสามารถขอแก้ไขข้อมูลของผู้ให้ข้อมูลให้ถูกต้อง สมบูรณ์ และเป็นปัจจุบันได้ หากผู้ให้ข้อมูลพบว่าข้อมูลของผู้ให้ข้อมูลไม่ถูกต้อง สมบูรณ์ และเป็นปัจจุบัน บีนีทไม่สามารถตรวจสอบและแก้ไขข้อมูลดังกล่าวได้ด้วยตนเอง\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ทั้งนี้ ในบางกรณีตามสภาพของการดำเนินการ บีนีทอาจไม่สามารถดำเนินการได้ตามที่ผู้ให้ข้อมูลร้องขอได้ เช่น เมื่ออยู่ระหว่างการดำเนินกระบวนการทางกฎหมาย เป็นต้น ทั้งนี้ขอให้ผู้ให้ข้อมูลรับทราบว่าบีนีทจะบันทึกรายการต่างๆ ที่ได้ดำเนินการเกี่ยวกับคำร้องของผู้ให้ข้อมูลเอาไว้เพื่อใช้ในการแก้ไขปัญหาต่างๆ ที่เกิดขึ้น\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v("\n          ข้อ 7. คุกกี้ (Cookie)\n        ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          คุกกี้คือไฟล์ที่เว็บไซต์ของบีนีทสร้างขึ้นเพื่อบันทึกข้อมูลการท่องเว็บ เว็บไซต์ของบีนีทจะใช้คุกกี้เพื่อให้ผู้ให้ข้อมูลลงชื่อเข้าใช้งานแพลตฟอร์มของบีนีทได้อยู่เสมอ เพื่ออำนวยความสะดวกในการติดต่อสื่อสาร รวมถึงเพื่อเพิ่มประสิทธิภาพในการใช้งานเว็บไซต์ให้ดียิ่งขึ้น และเพื่อให้ได้รับการบริการที่ดีที่สุด โดยบีนีทไม่ได้บันทึกข้อมูลส่วนบุคคลของบุคคลใดบุคคลหนึ่งโดยเฉพาะและบีนีทจะจัดเก็บข้อมูลคุกกี้ไว้เป็นเวลา 12 เดือน\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 8. การรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บีนีทได้จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยสำหรับข้อมูลส่วนบุคคลของผู้ให้ข้อมูล นอกจากนี้ หน่วยงานภายนอกซึ่งประมวลผลข้อมูลส่วนบุคคลให้บีนีทจะต้องดำเนินการตามมาตรการรักษาความมั่นคงปลอดภัยของบีนีท และจะต้องตกลงที่จะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของผู้ให้ข้อมูล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          นอกจากนี้ พนักงาน ลูกจ้าง ตัวแทนหรือผู้ให้บริการภายนอกของบีนีทมีหน้าที่ต้องรักษาความลับของข้อมูลส่วนบุคคลของผู้ให้ข้อมูลตามสัญญารักษาความลับที่ลงนามไว้กับบีนีทด้วยเช่นกัน ในกรณีที่บีนีทส่งข้อมูลส่วนบุคคลไปต่างประเทศที่มีมาตรฐานการจัดการข้อมูลส่วนบุคคลต่ำกว่าประเทศไทย บีนีทจะดำเนินมาตรการตามที่เห็นว่าจำเป็น อย่างน้อยตามมาตรฐานการรักษาความลับที่กฎหมายประเทศนั้นๆ กำหนดไว้ เช่น บีนีทมีข้อสัญญารักษาความลับกับคู่สัญญาในประเทศดังกล่าว เป็นต้น\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          ข้อ 9. ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          บีนีทจะจัดเก็บข้อมูลส่วนบุคคลของผู้ให้ข้อมูลไว้ตราบเท่าที่จำเป็นเพื่อการใช้ตามวัตถุประสงค์ของบีนีท และ/หรือ เพื่อการกำกับดูแล เพื่อบริหารความเสี่ยงของบีนีท เพื่อการปฏิบัติตามข้อกำหนดทางกฎหมาย เช่น กฎหมายป้องกันและปราบปรามการฟอกเงิน ที่ให้บีนีทจัดเก็บข้อมูลของผู้ให้ข้อมูลไว้เป็นเวลา 10 ปี นับแต่วันที่ผู้ให้ข้อมูลสิ้นสุดสัญญากับบีนีท เว้นแต่บีนีท ใช้สิทธิเรียกร้องตามกฎหมาย หรืออยู่ระหว่างกระบวนการตามกฎหมาย จนกว่าคดีจะถึงที่สุด ทั้งนี้หากบีนีท ไม่จำเป็นต้องใช้ข้อมูลส่วนบุคคลอีกต่อไป บีนีท จะลบข้อมูลนั้นออกจากระบบ และ/หรือดำเนินการให้ข้อมูลนั้นกลายเป็นข้อมูลที่ไม่สามารถบ่งชี้ตัวบุคคล เพื่อที่ผู้ให้ข้อมูลจะไม่สามารถถูกบ่งชี้ตัวตนจากข้อมูลนั้นได้อีกต่อไป ทั้งนี้บีนีทจะดำเนินการภายใต้ภาระหน้าที่การดำรงข้อมูลไว้ตามกฎหมายที่เกี่ยวข้อง\n        "
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-388e2e56", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388e2e56","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/ServiceProviderPrivacy.vue
// module id = 1521
// module chunks = 0